'use client'

import TEST_IDS from 'labels/constants/testIds'
import { cx } from 'utils/cx'
import styles from '../GenericStyles.module.scss'

export type ClientButtonProps = Readonly<
	React.ButtonHTMLAttributes<HTMLButtonElement>
>

export function ClientButton(props: ClientButtonProps): React.ReactElement {
	const { className, children, ...rest } = props

	return (
		<button
			data-testid={TEST_IDS.BUTTON}
			type='button'
			className={cx(className, styles.button)}
			{...rest}
		>
			{children}
		</button>
	)
}
